export default {
  user (state) {
    return state.user
  },
  userGroups (state) {
    return state.groups.user
  }
}
